import React from 'react';
import { cn } from '@/lib/utils';

const SlateButton = React.forwardRef(({ 
  className, 
  children, 
  disabled = false,
  onClick,
  type = 'button',
  size = 'md',
  ...props 
}, ref) => {
  const sizeClasses = {
    sm: 'h-[28px] px-4 text-xs',
    md: 'h-[44px] px-6 text-sm',
    lg: 'h-[52px] px-8 text-base',
    xl: 'h-[60px] px-10 text-lg'
  };

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'relative inline-flex items-center justify-center gap-2',
        'rounded-[var(--radius-xl)] font-semibold font-["Sora"]',
        'text-white',
        'transition-all duration-180',
        'overflow-hidden',
        'hover-lift',
        'focus-ring',
        'interactive',
        !disabled && 'hover:opacity-90',
        !disabled && 'active:scale-[0.98]',
        disabled && 'disabled opacity-50 cursor-not-allowed',
        sizeClasses[size],
        className
      )}
      style={{
        background: 'linear-gradient(135deg, #5A7BA3 0%, #3D5A80 50%, #2A3F5A 100%)',
        boxShadow: 'var(--shadow-md)'
      }}
      data-testid={props['data-testid']}
      {...props}
    >
      {/* Subtle Highlight */}
      <span 
        className="absolute inset-0" 
        style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 40%, rgba(0,0,0,0.05) 100%)'
        }}
      />
      
      {/* Content */}
      <span className="relative z-10 flex items-center gap-2">
        {children}
      </span>
    </button>
  );
});

SlateButton.displayName = 'SlateButton';

export { SlateButton };